import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

interface UserDetailsProps {
  type?: "EDIT" | "CONFIRM";
}

function UserDetails({ type = "EDIT" }: UserDetailsProps) {
  const { t } = useTranslation();
  const info = useSelector((state: any) => state.info?.allData);
  return (
    <Stack direction={"column"} sx={{ p: 2.25 }}>
      {type === "EDIT" ? (
        <Typography color="#666666" fontWeight={600}>
          {`${t("enter_details_for_id", {
            defaultValue: "Enter details for Customer ID",
          })}: ${info?.customerId || "-"}`}
        </Typography>
      ) : (
        <Typography color="#666666" fontWeight={600}>
          {`${t("confirm_details_for_id", {
            defaultValue: "Confirm details for Customer ID",
          })}: ${info?.customerId || "-"}`}
        </Typography>
      )}
      <Typography color="primary">
        {info?.shopName || info?.ownerName || "-"}
      </Typography>
    </Stack>
  );
}

export default memo(UserDetails);
